import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Container, Flex, Grid } from '@chakra-ui/react';
import { Area } from '@whitbread-eos/api';
import { Icon, LanguageSelectorSwitcher, Logo } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useCustomLocale } from '@whitbread-eos/utils';
import React, { useEffect, useState } from 'react';
import { getListOfLanguagesForSwitcher } from '../../helpers/helpers';
import { containerLogoStyle, containerWrapperStyles, contentStyles, headerWrapperStyles } from '../HeaderLeisure.style';
import NavigationMenu from '../NavigationMenu';
import NavigationMenuMobile from '../NavigationMenuMobile';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderVariantDefault(_ref) {
  var _content$header, _content$global;
  var headerInfoData = _ref.headerInfoData,
    hotelBrand = _ref.hotelBrand,
    useNextImage = _ref.useNextImage;
  var content = headerInfoData.content,
    config = headerInfoData.config;
  var _useCustomLocale = useCustomLocale(),
    currentLanguage = _useCustomLocale.language,
    currentCountry = _useCustomLocale.country;
  var isWindowDefined = typeof window !== 'undefined';
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    origin = _useState2[0],
    setOrigin = _useState2[1];
  var _useState3 = useState(_jsx(_Fragment, {})),
    _useState4 = _slicedToArray(_useState3, 2),
    tickIcon = _useState4[0],
    setTickIcon = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var countries = content === null || content === void 0 ? void 0 : content.countries;
  useEffect(() => {
    setOrigin(window.location.origin);
  }, [isWindowDefined]);
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    languagesList = _useState8[0],
    setLanguagesList = _useState8[1];
  var _useState9 = useState({
      business: '',
      businessSubNav: {
        title: '',
        navOptions: [{
          title: '',
          url: ''
        }]
      },
      logIn: '',
      logOut: '',
      findBooking: '',
      discoverPI: '',
      subNav: [{
        title: '',
        navOptions: [{
          title: '',
          url: ''
        }]
      }],
      accountLinks: [],
      mobileMenuButton: '',
      language: '',
      signUpButton: ''
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    navigationLabels = _useState0[0],
    setNavigationLabels = _useState0[1];
  useEffect(() => {
    if (countries !== null && countries !== void 0 && countries.length) {
      var _content$menu, _content$menu2, _content$menu3, _content$menu4, _content$menu5, _content$authenticati, _config$authenticatio, _config$authenticatio2, _content$menu6, _content$menu7, _content$authenticati2;
      setLanguagesList(getListOfLanguagesForSwitcher(countries));
      setTickIcon(_jsx(Icon, {
        src: formatAssetsUrl(content === null || content === void 0 || (_content$menu = content.menu) === null || _content$menu === void 0 ? void 0 : _content$menu.tick),
        color: "var(--chakra-colors-primary)"
      }));
      setIsLoading(false);
      setNavigationLabels({
        discoverPI: content === null || content === void 0 || (_content$menu2 = content.menu) === null || _content$menu2 === void 0 ? void 0 : _content$menu2.discoverPI,
        business: content === null || content === void 0 || (_content$menu3 = content.menu) === null || _content$menu3 === void 0 ? void 0 : _content$menu3.business,
        businessSubNav: getBusinessOptions(content === null || content === void 0 ? void 0 : content.subNav),
        findBooking: content === null || content === void 0 || (_content$menu4 = content.menu) === null || _content$menu4 === void 0 ? void 0 : _content$menu4.findBooking,
        logIn: content === null || content === void 0 || (_content$menu5 = content.menu) === null || _content$menu5 === void 0 ? void 0 : _content$menu5.logIn,
        logOut: content === null || content === void 0 || (_content$authenticati = content.authentication) === null || _content$authenticati === void 0 ? void 0 : _content$authenticati.logoutButton,
        subNav: filterBusinessOptions(content === null || content === void 0 ? void 0 : content.subNav),
        accountLinks: (_config$authenticatio = config === null || config === void 0 || (_config$authenticatio2 = config.authentication) === null || _config$authenticatio2 === void 0 ? void 0 : _config$authenticatio2.accountLinks) !== null && _config$authenticatio !== void 0 ? _config$authenticatio : [],
        mobileMenuButton: content === null || content === void 0 || (_content$menu6 = content.menu) === null || _content$menu6 === void 0 ? void 0 : _content$menu6.mobileMenuButton,
        language: content === null || content === void 0 || (_content$menu7 = content.menu) === null || _content$menu7 === void 0 ? void 0 : _content$menu7.language,
        signUpButton: content === null || content === void 0 || (_content$authenticati2 = content.authentication) === null || _content$authenticati2 === void 0 ? void 0 : _content$authenticati2.signUpButton
      });
    }
  }, [content, config]);
  return _jsx(Box, _objectSpread(_objectSpread({}, customHeaderWrapperStyles), {}, {
    "data-testid": "common-header-wrapper",
    children: _jsx(Container, _objectSpread(_objectSpread({}, containerWrapperStyles), {}, {
      children: _jsxs(Grid, _objectSpread(_objectSpread({}, contentStyles), {}, {
        sx: {
          '@media print': {
            py: 'sm'
          }
        },
        children: [_jsx(Flex, _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
          "data-testid": "logo-container",
          children: !isLoading && _jsx(Logo, {
            href: "".concat(origin, "/").concat(currentCountry, "/").concat(currentLanguage, "/home.html"),
            src: formatAssetsUrl(content === null || content === void 0 || (_content$header = content.header) === null || _content$header === void 0 ? void 0 : _content$header.image),
            variant: hotelBrand,
            alt: content === null || content === void 0 || (_content$global = content.global) === null || _content$global === void 0 || (_content$global = _content$global.brand) === null || _content$global === void 0 ? void 0 : _content$global[hotelBrand],
            useNextImage: useNextImage
          })
        })), _jsxs(Grid, {
          templateColumns: "1fr auto",
          alignItems: 'center',
          display: {
            mobile: 'none',
            lg: 'grid'
          },
          sx: {
            '@media print': {
              display: 'none'
            }
          },
          children: [!isLoading && _jsx(LanguageSelectorSwitcher, {
            currentLanguage: currentLanguage,
            languagesList: languagesList,
            prefixDataTestId: "pi",
            tickIcon: tickIcon,
            area: Area.PI
          }), _jsx(NavigationMenu, {
            labels: navigationLabels
          })]
        }), _jsx(Grid, {
          display: {
            mobile: 'grid',
            lg: 'none'
          },
          justifyContent: 'end',
          children: !isLoading && _jsx(NavigationMenuMobile, {
            currentLanguage: currentLanguage,
            languagesList: languagesList,
            tickIcon: tickIcon,
            area: Area.PI,
            labels: navigationLabels
          })
        })]
      }))
    }))
  }));
  function getBusinessOptions(list) {
    var _list$find;
    if (!list) {
      return {
        title: '',
        navOptions: [{
          title: '',
          url: ''
        }]
      };
    }
    return (_list$find = list.find(item => item.title.includes('Business'))) !== null && _list$find !== void 0 ? _list$find : {
      title: '',
      navOptions: [{
        title: '',
        url: ''
      }]
    };
  }
  function filterBusinessOptions(list) {
    if (!list) {
      return [];
    }
    return list.filter(item => !item.title.includes('Business') && item.title.trim().length > 0);
  }
}
var customHeaderWrapperStyles = _objectSpread(_objectSpread({}, headerWrapperStyles), {}, {
  h: {
    mobile: 'var(--chakra-space-4xl)',
    lg: 'var(--chakra-space-6xl)'
  }
});